export const getVacqueyrasData = () => ({
  name: "Vacqueyras",
  region: "Rhône",
  country: "France",
  description: "Vacqueyras est une appellation prestigieuse du Rhône méridional, produisant des vins rouges puissants et des vins blancs aromatiques dans un terroir unique.",
  type: "subregion",
  area: "1,400 ha",
  production: "50,000 hectolitres",
  mapAreas: [
    { region: "Vacqueyras", x: 51, y: 68, color: "#4B164C", size: 4 }
  ],
  characteristics: {
    climate: "Climat méditerranéen chaud et sec",
    soil: "Sols de calcaire, argile et galets roulés",
    viticulture: "Viticulture traditionnelle, vendanges manuelles, rendements limités"
  },
  wineStyles: {
    red: "Vins rouges puissants et équilibrés, avec des notes de fruits mûrs et d'épices",
    white: "Vins blancs aromatiques et complexes, avec des notes de fruits exotiques",
    rose: "Rosés fruités et équilibrés, avec une belle structure"
  },
  history: "Vacqueyras produit des vins depuis l'époque romaine. L'appellation est reconnue depuis 1990. Le nom vient de 'Vallis Clavea' (vallée des clés) en latin.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine provençale",
  grapeVarieties: [
    {
      name: "Grenache",
      percentage: "60%",
      description: "Cépage principal de Vacqueyras, produisant des vins puissants et fruités",
      characteristics: "Puissant, fruité, alcool élevé, notes de fruits rouges mûrs",
      wineStyles: "Sec, plein-corps, fruité"
    },
    {
      name: "Syrah",
      percentage: "25%",
      description: "Cépage d'assemblage, apportant structure et couleur",
      characteristics: "Structuré, coloré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Mourvèdre",
      percentage: "10%",
      description: "Cépage d'assemblage, apportant complexité et capacité de garde",
      characteristics: "Complexe, tannique, notes d'épices et de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Grenache Blanc",
      percentage: "3%",
      description: "Cépage blanc principal, pour les vins blancs",
      characteristics: "Riche, aromatique, notes de fruits exotiques",
      wineStyles: "Sec, plein-corps, aromatique"
    },
    {
      name: "Clairette",
      percentage: "2%",
      description: "Cépage blanc d'assemblage, apportant fraîcheur",
      characteristics: "Frais, neutre, acidité vive, notes d'agrumes",
      wineStyles: "Sec, léger, frais"
    }
  ]
}); 